import { ApiHandlerDiscreteParameter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { GetOrderApiParameter } from "@insite/client-framework/Services/OrderService";
import loadOrderByOrderNumber from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrderByOrderNumber";
import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { chain,DispatchLoadOrderIfNeeded } from "@insite/client-framework/Store/Pages/OrderDetails/Handlers/DisplayOrder";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    { orderNumber: string; expand?: ("orderLines" | "shipments" | "vmidetails")[] },
    GetOrderApiParameter,
    OrderModel
>;

export const CustomDispatchLoadOrderIfNeeded: HandlerType = props => {
    const orderState = getOrderState(props.getState(), props.parameter.orderNumber);
    if ((!orderState?.value && !orderState?.isLoading) || !orderState?.value?.orderLines) {
        props.dispatch(loadOrderByOrderNumber(props.parameter));
    }
};


replaceInChain(chain,DispatchLoadOrderIfNeeded,CustomDispatchLoadOrderIfNeeded);